import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({

   modules: {

      loginlogout: {
         state: {
            userID: '',
            loadingStartScreen: true,
            loadingWorkingScreen: false,
            zammadID: '',
            zammadToken: '',
            email: '',
            userTickets: {
               page1: "",
               page2: "",
               page3: "",
               page4: "",
               page5: "",
               page6: "",
               page7: "",
               page8: ""
            },
            loadedArticles: {},
            attachments: {},
            currentPage: 1,
            agents: [
               {
                  id: 4,
                  name: "Andreas Starke",
               },
               {
                  id: 6,
                  name: "Annika Tiedemann",
               },
               {
                  id: 47,
                  name: "Erik Elges",
               },
               {
                  id: 46,
                  name: "Hauke Köhne",
               },
               {
                  id: 45,
                  name: "Manfred Kleischmann",
               },
               {
                  id: 48,
                  name: "Monique Ostermann",
               },
               {
                  id: 41,
                  name: "Patrick Matern",
               },
               {
                  id: 43,
                  name: "Marcus Hartmann",
               },
               {
                  id: 7,
                  name: "Marvin Rissiek",
               }
            ]
         },
         mutations: {
            auth_success(state, userID) {
               //state.status = 'success'
               state.userID = userID
            },
            set_user_email(state, email) {
               state.email = email
            },
            set_zammad_id(state, id) {
               state.zammadID = id
            },
            set_zammad_token(state, token) {
               state.zammadToken = token
            },
            setLoadingStartScreen(state) {
               state.loadingStartScreen = true
            },
            setStopLoadingStartScreen(state) {
               state.loadingStartScreen = false
            },
            setLoadingWorkingScreen(state) {
               state.loadingWorkingScreen = true
            },
            setStopLoadingWorkingScreen(state) {
               state.loadingWorkingScreen = false
            },
            setUserTickets(state, payload) {
               state.userTickets[payload.page] = payload.tickets
            },
            ticketPageWhenStart(state, page) {
               state.currentPage = page
            },
            setNewUserTicket(state, ticket) {
               state.userTickets.push(ticket)
            },
            setLoadedArticles(state, articles) {
               state.loadedArticles = articles
            },
            setAddNewArticle(state, article) {
               state.loadedArticles.push(article)
            },
            setAttachmentsForArticles(state, attachment) {
               state.attachments.push(attachment)
            }
         },
         actions: {

            isLoggedIn({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/is-logged-in',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     commit('auth_success', resp.data.user_id)
                     commit('set_user_email', resp.data.email)
                     commit('set_zammad_id', resp.data.zammad_id)
                     commit('set_zammad_token', resp.data.zammad_token)
                     commit('setStopLoadingStartScreen')
                     resolve(resp)
                  })
                  .catch(err => {
                     commit('auth_success', '')
                     commit('set_user_email', '')
                     commit('set_zammad_id', '')
                     commit('set_zammad_token', '')
                     commit('setStopLoadingStartScreen')
                     reject(err)
                  })
               })
            },

            createOrganization({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/organizations',
                     method: 'POST',
                     params: {
                        'organization': data.organization,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            createCustomer({ commit }, data) {
               //hier wird die ID des Users generiert, der dann in Wordpress gespeichert werden muss -> updateZammadUserID
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/users',
                     //url: 'http://zammad.oxs' + '/api/v1/users',
                     method: 'POST',
                     // data: {
                     //    'firstname': user.firstname,
                     //    'lastname': user.lastname,
                     //    'email': user.email,
                     //    'organization': user.organization, //Organisation muss bereits vorhanden sein
                     //    'password': user.password
                     // },
                     params: {
                        'firstname': data.firstname,
                        'lastname': data.lastname,
                        'email': data.email,
                        'organization': data.organization, //Organisation muss bereits vorhanden sein
                        'password': data.password,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            getUser({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/get_user',
                     method: 'GET',
                     params: {
                        'user_id': data.user_id,
                        'zammad_token': data.zammad_token,
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            createCustomerToken({ commit }, data) {
               //hier wird der Token generiert, der dann in Wordpress gespeichert werden muss -> updateZammadToken
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/user_access_token',
                     //url: 'http://zammad.oxs' + '/api/v1/user_access_token',
                     method: 'POST',
                     // auth: {
                     //    username: credentials.username,
                     //    password: credentials.password
                     // },
                     // data: {
                     //    'label': 'customer_token',
                     //    'permission': [ 'ticket.customer' ],
                     //    'expires_at': null,
                     //    'username': data.username,
                     //    'password': data.password,
                     //    '_wpnonce': data.nonce
                     // },
                     params: {
                        'username': data.username,
                        'password': data.password,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },


            updateZammadToken({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/wp/v2/users/' + data.user_id,
                     method: 'POST',
                     data: {
                        meta: {
                           'zammad_token': data.zammad_token.toString()
                        }
                     },
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            updateZammadUserID({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/wp/v2/users/' + data.user_id,
                     method: 'POST',
                     data: {
                        meta: {
                           'zammad_id': data.zammad_id.toString()
                        }
                     },
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            createTicket({ commit }, data) {
               return new Promise((resolve, reject) => {

                  if (typeof data.attachments != "undefined" && data.attachments != null && data.attachments.length != null && data.attachments.length > 0) {
                     axios({
                        url: data.restURL + '/custom/v1/zammad/create_ticket_with_attachment',
                        method: 'POST',
                        data: {
                           'title': data.title,
                           'priority_id': data.priority_id,
                           'subject': data.subject,
                           'note': data.note,
                           'body': data.body,
                           'user_email': data.user_email,
                           'zammad_token': data.zammad_token,
                           'zammad_id': data.zammad_id,
                           '_wpnonce': data.nonce,
                           'attachments': data.attachments
                        }
                     })
                     .then(resp => {
                        //commit('setNewUserTicket', resp.data)
                        resolve(resp)
                     })
                     .catch(err => {
                        reject(err)
                     })
                  } else {
                     axios({
                        url: data.restURL + '/custom/v1/zammad/create_ticket',
                        method: 'POST',
                        data: {
                           'title': data.title,
                           'priority_id': data.priority_id,
                           'subject': data.subject,
                           'note': data.note,
                           'body': data.body,
                           'user_email': data.user_email,
                           'zammad_token': data.zammad_token,
                           'zammad_id': data.zammad_id,
                           '_wpnonce': data.nonce
                        }
                     })
                     .then(resp => {
                        //commit('setNewUserTicket', resp.data)
                        resolve(resp)
                     })
                     .catch(err => {
                        reject(err)
                     })
                  }
               })
            },

            createNewArticle({ commit }, data) {
               return new Promise((resolve, reject) => {

                  if (typeof data.attachments != "undefined" && data.attachments != null && data.attachments.length != null && data.attachments.length > 0) {
                     axios({
                        url: data.restURL + '/custom/v1/zammad/create_article_with_attachment',
                        method: 'POST',
                        data: {
                           'ticket_id': data.ticket_id,
                           'body': data.body,
                           'subject': data.subject,
                           'content_type': data.content_type,
                           'type': data.type,
                           'zammad_token': data.zammad_token,
                           'zammad_id': data.zammad_id,
                           '_wpnonce': data.nonce,
                           'attachments': data.attachments
                        }
                     })
                     .then(resp => {
                        commit('setAddNewArticle', resp.data.data)
                        resolve(resp)
                     })
                     .catch(err => {
                        reject(err)
                     })
                  } else {
                     axios({
                        url: data.restURL + '/custom/v1/zammad/create_article',
                        method: 'POST',
                        data: {
                           'ticket_id': data.ticket_id,
                           'body': data.body,
                           'subject': data.subject,
                           'content_type': data.content_type,
                           'type': data.type,
                           'zammad_token': data.zammad_token,
                           'zammad_id': data.zammad_id,
                           '_wpnonce': data.nonce
                        }
                     })
                     .then(resp => {
                        commit('setAddNewArticle', resp.data.data)
                        resolve(resp)
                     })
                     .catch(err => {
                        reject(err)
                     })
                  }
               })
            },

            listTickets({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/list_tickets',
                     method: 'GET',
                     params: {
                        'page': data.page,
                        'zammad_token': data.zammad_token,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     //console.log(data.page)
                     //commit('setUserTickets', resp.data.data)
                     if(resp.data.data.length > 0) {
                        //console.log(resp.data.data)
                        commit('setUserTickets', { page: 'page' + data.page, tickets: resp.data.data })
                     } else {
                        commit('ticketPageWhenStart', data.page-1)
                        //console.log(data.page-1)
                        resolve(resp)
                     }
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            showArticlesFromTicket({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/show_articles_from_ticket',
                     method: 'GET',
                     params: {
                        'ticket_id': data.ticket_id,
                        'zammad_token': data.zammad_token,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            showAttachmentFromArticles({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/show_attachment_from_article',
                     method: 'GET',
                     params: {
                        'ticket_id': data.ticket_id,
                        'article_id': data.article_id,
                        'attachment_id': data.attachment_id,
                        'attachment_mimetype': data.attachment_mimetype,
                        'zammad_token': data.zammad_token,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            showTicket({ commit, dispatch }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/zammad/show_ticket',
                     method: 'GET',
                     params: {
                        'ticket_id': data.ticket_id,
                        'zammad_token': data.zammad_token,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {

                     if (resp.data.code == "200") {

                        var attachments = []

                        var ticket_resp = resp.data.data

                        var ticket_data = {
                           'ticket_id': data.ticket_id,
                           'zammad_token': data.zammad_token,
                           '_wpnonce': data.nonce,
                           'restURL': data.restURL                      
                        }

                        dispatch('showArticlesFromTicket', ticket_data)
                           .then(resp => {

                              if (resp.data.code == "200") {

                                 var response = {
                                    'code': resp.data.code,
                                    'ticket': ticket_resp,
                                    'articles': resp.data.data
                                 }

                                 commit('setLoadedArticles', resp.data.data)

                                 // if (response.articles.length > 0) {
                                 //    for (var i = 0; i < response.articles.length; i++) {
                                 //       if (response.articles[i].attachments.length > 0) {

                                 //          var attachment_ticket_id = response.articles[i].ticket_id;
                                 //          var attachment_article_id = response.articles[i].id;

                                 //          for (var x = 0; x < response.articles[i].attachments.length; x++) {

                                 //             var attachment_id = response.articles[i].attachments[x].id;
                                 //             var attachment_mimetype = response.articles[i].attachments[x].preferences["Mime-Type"];

                                 //             var attachment_data = {
                                 //                'ticket_id': attachment_ticket_id,
                                 //                'article_id': attachment_article_id,
                                 //                'attachment_id': attachment_id,
                                 //                'attachment_mimetype': attachment_mimetype,
                                 //                'zammad_token': data.zammad_token,
                                 //                '_wpnonce': data.nonce,
                                 //                'restURL': data.restURL                                              
                                 //             }

                                 //             dispatch('showAttachmentFromArticles', attachment_data)
                                 //                .then(resp => {

                                 //                   if (resp != "fehler") {

                                 //                      var att = {
                                 //                         'ticket_id': attachment_ticket_id,
                                 //                         'article_id': attachment_article_id,
                                 //                         'attachment_id': attachment_id,
                                 //                         'base64': resp.data
                                 //                      }

                                 //                      attachments.push(att)

                                 //                      resolve(resp)

                                 //                   } else {
                                 //                      console.log("Can't load image.")
                                 //                      resolve("Can't load image.")
                                 //                   }
                                 //                })
                                 //                .catch(err => reject(err))

                                 //          }                                          
                                 //       } else {
                                 //          //keine Attachments am Artikel

                                 //       }
                                 //    }

                                 //    var response = {
                                 //       'code': resp.data.code,
                                 //       'ticket': ticket_resp,
                                 //       'articles': resp.data.data,
                                 //       'attachments': attachments
                                 //    }

                                 //    commit('setLoadedArticles', resp.data.data)

                                 resolve(response)


                                 // } else {
                                 //    console.log("error3")
                                 //    resolve("error3")
                                 // }

                              } else {
                                 console.log("error2")
                                 resolve("error2")
                              }
                           })
                           .catch(err => reject(err))

                     } else {
                        console.log("error1")
                        resolve("error1")
                     }

                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            initializeZammad({ commit, dispatch }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/proof-password',
                     method: 'GET',
                     params: {
                        'password': data.password,
                        '_wpnonce': data.nonce
                     }
                  })
                  .then(resp => {
                     if (resp.data.result) {

                        var restURL = data.restURL

                        var organization = resp.data.user_company

                        var logged_in_user = {
                           'user_id': resp.data.user_id,
                           'user_email': resp.data.user_email,
                           'user_firstname': resp.data.user_firstname,
                           'user_lastname': resp.data.user_lastname
                        }

                        var organization_data = {
                           'organization': organization,
                           'restURL': restURL,
                           'nonce': data.nonce
                        }

                        dispatch('createOrganization', organization_data)
                           .then(resp => {

                              if (resp.data.code == "201" || resp.data.code == "422") {

                                 console.log(resp.data)

                                 var user_data = {
                                    'user_id': logged_in_user.user_id,
                                    'password': data.password,
                                    'firstname': logged_in_user.user_firstname,
                                    'lastname': logged_in_user.user_lastname,
                                    'organization': organization,
                                    'email': logged_in_user.user_email,
                                    'nonce': data.nonce,
                                    'restURL': restURL
                                 }

                                 console.log(user_data)

                                 dispatch('createCustomer', user_data)
                                    .then(resp => {

                                       if (resp.data.code == "201") {
                                          //TODO
                                          var zammad_id = resp.data.data.id
                                          var zammad_id_data = {
                                             'user_id': logged_in_user.user_id,
                                             'zammad_id': zammad_id,
                                             'restURL': restURL,
                                             'nonce': data.nonce
                                          }
                                          dispatch('updateZammadUserID', zammad_id_data)
                                             .then(resp => {
                                                commit('set_zammad_id', zammad_id)

                                                var credentials_data = {
                                                   'username': logged_in_user.user_email,
                                                   'password': data.password,
                                                   'restURL': restURL,
                                                   'nonce': data.nonce
                                                }

                                                dispatch('createCustomerToken', credentials_data)
                                                   .then(resp => {

                                                      console.log(resp.data.code)

                                                      if (resp.data.code == "200") {
                                                         //TODO
                                                         var zammad_token = resp.data.data.token
                                                         var zammad_token_data = {
                                                            'user_id': logged_in_user.user_id,
                                                            'zammad_token': zammad_token,
                                                            'restURL': restURL,
                                                            'nonce': data.nonce
                                                         }

                                                         dispatch('updateZammadToken', zammad_token_data)
                                                            .then(resp => {
                                                               commit('set_zammad_token', zammad_token)
                                                               resolve("success")

                                                            })
                                                            .catch(err => reject(err))
                                                      
                                                      } else {
                                                         console.log("error4")
                                                         resolve("error4")
                                                      }

                                                   })
                                                   .catch(err => reject(err))
                                             })
                                             .catch(err => reject(err))

                                       } else {
                                          console.log("error3")
                                          resolve("error3")
                                       }
                                    })
                                    .catch(err => reject(err))
                                 
                              } else {
                                 console.log("error2")
                                 resolve("error2")
                              }


                           })
                           .catch(err => {
                              console.log(err)
                              reject(err)
                           })
                     } else {
                        console.log("error1")
                        resolve("error1")
                     }
                  })
                  .catch(err => {
                     console.log(err)
                     reject(err)
                  })
               })
            },

            //LQcjYsRtFvx_zcByAWFW9rt3xCliuOSVWO9vh5FGIYvzMwgnlekAL0FxlEs6U43O            
         },
         getters: {
            isLoggedIn: state => state.userID,
            getUserEmail: state => state.email,
            getZammadID: state => state.zammadID,
            getZammadToken: state => state.zammadToken,
            getAllUserTickets: state => state.userTickets,
            getLoadingStartScreen: state => state.loadingStartScreen,
            getLoadingWorkingScreen: state => state.loadingWorkingScreen,
            getLoadedArticles: state => state.loadedArticles,
            getAttachmentsForArticles: state => state.attachments,
            getAgents: state => state.agents,
            getCurrentPage: state => state.currentPage
         }

      }
   }
})


// WEBPACK FOOTER //
// ./src/store/index.js